import { useEffect, useState } from "react";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { Col, Container, Row, CardBody, Card } from "reactstrap";
// Assuming NewsService returns a custom hook or object
import { NewsService } from "../../Service/NewsEvents/NewsService";
import "./NewsEvent.scss";

// Step 1: Define a type for a single news item.
interface NewsItem {
  NewsId: number;
  NewsHeading: string;
  NewsIconImage: string;
  NewsDetail: string;
  NewsDescription: string;
  EntryDate: string;
}

const imageBasePath = `${import.meta.env.VITE_APP_ADMIN_API_URL.replace("API/api/WorkForce/", "")}NewsImage/`;

const NewsEventsCompo = () => {
  // Step 2: Use the defined type for the state.
  const [news, setNews] = useState<NewsItem[]>([]);
  const [popupIdx, setPopupIdx] = useState<number | null>(null);

  const { fetchNews } = NewsService();

  useEffect(() => {
    const loadNews = async () => {
      // The fetchNews function should be typed to return Promise<NewsItem[] | any>
      const data = await fetchNews();
      
      // Explicitly check if data is an array before setting state.
      // This is good practice.
      if (Array.isArray(data)) {
        setNews(data);
      }
    };
    loadNews();
  }, []); // Add fetchNews to the dependency array

  useEffect(() => {
    if (popupIdx !== null) {
      const onKey = (e: KeyboardEvent) => {
        if (e.key === "Escape") setPopupIdx(null);
      };
      window.addEventListener("keydown", onKey);
      return () => window.removeEventListener("keydown", onKey);
    }
  }, [popupIdx]);

  return (
    <>
      <Breadcrumbs mainTitle={"News And Events"} parent={"News And Events"} />
      <Container fluid>
        <Row>
          <Col>
            <Card>
              <CardBody className="pt-1">
                <div className="cards-wrapper">
                  {/* Check for news.length is a good way to handle no data */}
                  {news.length === 0 && <p>No news available.</p>}
                  
                  {/* The .map function is now fully typed */}
                  {news.map((item: NewsItem, idx: number) => (
                    <div className="card-container" key={item.NewsId}>
                      <h3 className="card-heading">{item.NewsHeading}</h3>
                      <div className="card-content">
                        <img
                          src={imageBasePath + item.NewsIconImage}
                          alt={item.NewsHeading}
                          className="card-image"
                        />
                        <div className="card-details">
                          {/* The dangerouslySetInnerHTML is not needed here */}
                          <p className="card-desc">{item.NewsDetail}</p>
                          <button
                            className="read-more-btn"
                            onClick={() => setPopupIdx(idx)}
                          >
                            READ MORE
                          </button>
                        </div>
                      </div>
                      <div className="card-footer">
                        <span>📅 Posted On : {item.EntryDate}</span>
                      </div>
                      {/* Using the item object to display the full news content */}
                      {popupIdx === idx && (
                        <div
                          className="popup-overlay"
                          role="dialog"
                          aria-modal="true"
                          onClick={() => setPopupIdx(null)}
                        >
                          <div
                            className="popup-content"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="popup-right">
                              <img
                                src={imageBasePath + item.NewsIconImage}
                                alt={item.NewsHeading}
                                className="popup-image"
                              />
                            </div>
                            <div className="popup-left">
                              <h2>{item.NewsHeading}</h2>
                              <p>{item.NewsDescription}</p>
                              <button
                                className="close-btn"
                                onClick={() => setPopupIdx(null)}
                              >
                                Close
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default NewsEventsCompo;